import { Component, OnInit } from '@angular/core';
import { BaseModalContainer, ModalContainerService, ModalService, UserService } from 'yt-ng-framework';
import { ActivatedRoute } from '@angular/router';
import { Opstina } from './opstina';

@Component({
  selector: 'app-opstina',
  templateUrl: './opstina.component.html'
})
export class OpstinaComponent extends BaseModalContainer<Opstina> implements OnInit {

  constructor (
      protected modalContainerService: ModalContainerService<Opstina>,
      protected activatedRoute: ActivatedRoute,
      protected modalService: ModalService,
      protected userService: UserService
  ){
      super(modalContainerService, activatedRoute, modalService, userService)
  }

  ngOnInit(){
  }
}
